import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { styles } from "./RightsView.styles";
import { useTranslation } from "react-i18next";

import {
    WithStyles,
    withStyles,
} from "@material-ui/core";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";

export interface IRightsViewProps extends WithStyles<typeof styles> {}

const RightsViewPure: React.FunctionComponent<IRightsViewProps> = ({ classes }) => {
    const {t} = useTranslation();
    return <CenteredContainer>
        <div className={classes.title}>
            <Typography variant="h2">{t("footer.intellectualRights.title")}</Typography>
            <Typography variant="h4">{t("footer.intellectualRights.websiteTitle")}</Typography>
            <Typography variant="body1">{t("footer.intellectualRights.websiteText")}</Typography>
            <Typography variant="h4">{t("footer.intellectualRights.termsTitle")}</Typography>
            <Typography variant="body1">{t("footer.intellectualRights.termsText1")}</Typography>
            <Typography variant="body1">{t("footer.intellectualRights.termsText2")}</Typography>
        </div>
    </CenteredContainer>;

};

export const RightsView = withStyles(styles)(RightsViewPure);
